import React, { useEffect } from 'react'
import { create } from 'zustand'

import { message, type MessageInstance } from 'src/ui/toast'

type TStore = {
  getMessage: () => MessageInstance
}

export const useAntdMessageWithContext = create<TStore>(() => ({
  getMessage: () => {
    throw new Error(`
      useAntdMessageWithContext is used without initializing: AntdMessageWithContextInit
    `)
  },
}))

export const AntdMessageWithContextInit = () => {
  const [messageAPI, messageJSX] = message.useMessage()

  useEffect(() => {
    useAntdMessageWithContext.setState({ getMessage: () => messageAPI })
  }, [messageAPI])

  return <>{messageJSX}</>
}
